// extracted by mini-css-extract-plugin
export default {"footerBrazeBannerSlot":"footerBrazeBanner_footerBrazeBannerSlot__5KTOl"};